/*
 * MyUSE stale Nuxt chunk recovery.
 *
 * Nuxt 2 creates hashed JavaScript chunks during each production build.
 *
 * A browser that was already open before a deployment can still contain
 * the old webpack route map. If the user later opens a lazy-loaded route,
 * that old application may request a chunk which no longer exists.
 *
 * Example:
 *
 *   Loading chunk 70 failed.
 *   /_nuxt/d89b809.js -> 404
 *
 * When that happens, perform ONE full application refresh with a unique
 * query parameter so the browser receives the current Nuxt application.
 *
 * The session is not cleared and no Vuex/auth mutations are performed here.
 */

export default function ({
    app,
  }) {
    if (
      !process.client ||
      typeof window === 'undefined'
    ) {
      return
    }
  
    const RECOVERY_KEY =
      'myuse-chunk-recovery'
  
    const isChunkLoadError = (
      error
    ) => {
      if (!error) {
        return false
      }
  
      const message =
        String(
          error.message ||
          error.name ||
          error
        )
  
      return (
        message.includes(
          'Loading chunk'
        ) ||
        message.includes(
          'ChunkLoadError'
        ) ||
        message.includes(
          'Loading CSS chunk'
        ) ||
        message.includes(
          'CSS_CHUNK_LOAD_FAILED'
        )
      )
    }
  
    const recover = (
      error
    ) => {
      if (!isChunkLoadError(error)) {
        return false
      }
  
      /*
       * Prevent an infinite refresh loop if the server genuinely
       * cannot provide the current build.
       */
      try {
        if (
          window.sessionStorage
            .getItem(
              RECOVERY_KEY
            ) === '1'
        ) {
          window.sessionStorage
            .removeItem(
              RECOVERY_KEY
            )
  
          return false
        }
  
        window.sessionStorage
          .setItem(
            RECOVERY_KEY,
            '1'
          )
      } catch (_) {}
  
      const url =
        new URL(
          window.location.href
        )
  
      url.searchParams.set(
        'myuse_refresh',
        String(
          Date.now()
        )
      )
  
      window.location.replace(
        url.toString()
      )
  
      return true
    }
  
    /*
     * Vue Router reports failed lazy-route imports here.
     */
    if (
      app.router &&
      typeof app.router.onError ===
        'function'
    ) {
      app.router.onError(
        (error) => {
          recover(error)
        }
      )
    }
  
    /*
     * Also catch rejected dynamic imports that are not surfaced
     * through Vue Router.
     */
    window.addEventListener(
      'unhandledrejection',
      (event) => {
        const error =
          event &&
          event.reason
            ? event.reason
            : event
  
        if (recover(error)) {
          try {
            event.preventDefault()
          } catch (_) {}
        }
      }
    )
  
    /*
     * Once the current application has loaded successfully,
     * allow a future deployment-related recovery.
     */
    window.setTimeout(
      () => {
        try {
          window.sessionStorage
            .removeItem(
              RECOVERY_KEY
            )
        } catch (_) {}
      },
      10000
    )
  }